import React from 'react';
import { FiEdit3 } from 'react-icons/fi';
import TooltipIconButton from '../../../layout/ReusableComponent/TooltipIconButton';
import { START_CONVERSATION_LABEL } from './messagingLabels';

/**
 * Opens the new-conversation picker.
 * Desktop: icon + tooltip only. Mobile: icon + label.
 */
export default function StartConversationButton({
  className = '',
  onClick,
  disabled = false,
  showLabel = true,
  ...rest
}) {
  return (
    <TooltipIconButton
      label={START_CONVERSATION_LABEL}
      tooltip={START_CONVERSATION_LABEL}
      tooltipPosition="bottom"
      icon={<FiEdit3 aria-hidden />}
      showLabel={showLabel}
      className={`messaging-start-conversation-btn${className ? ` ${className}` : ''}`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    />
  );
}
